export const JiraServiceManagementMarkBrand = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.057 19.7803L37.985 19.8473C39.385 19.8563 40.178 21.4553 39.338 22.5753L23.21 44.0863C18.14 40.2973 17.101 33.1153 20.89 28.0453L27.057 19.7803Z"
      fill="url(#paint0_linear_818_533)"
    />
    <path
      d="M20.8799 28.0451L10.0149 27.9781C8.61594 27.9691 7.82294 26.3731 8.65994 25.2531L24.6339 3.91406C29.7039 7.70306 30.7429 14.8851 26.9539 19.9551L20.8799 28.0441V28.0451Z"
      fill="#1D7AFC"
    />
    <defs>
      <linearGradient
        id="paint0_linear_818_533"
        x1="26.6233"
        y1="21.3952"
        x2="31.2178"
        y2="35.2838"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0055CC" />
        <stop offset="1" stopColor="#1D7AFC" />
      </linearGradient>
    </defs>
  </svg>
);
